import {
    HttpResponse,
    TenantDeviceSubscriptionModel,
    QueryModel,
    RequestParams,
    TenantDeviceSubscriptionModelIEnumerableApiResultSuccess,
    TenantDeviceSubscriptionModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class TenantDeviceSubscriptionsDataService implements CrudService<TenantDeviceSubscriptionModel, TenantDeviceSubscriptionModel> {
    getAll(query: CrudDataQuery<TenantDeviceSubscriptionModel>): Promise<CrudEnumerableResponse<TenantDeviceSubscriptionModel>> {
        return ApiService.api.getTenantDeviceSubscriptionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<TenantDeviceSubscriptionModel>): Promise<CrudEnumerableResponse<TenantDeviceSubscriptionModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TenantDeviceSubscriptionModel>> {
        return ApiService.api.getTenantDeviceSubscriptionById(id, params);
    }

    create(item: TenantDeviceSubscriptionModel, params?: RequestParams): Promise<CrudResponse<TenantDeviceSubscriptionModel>> {
        return ApiService.api.insertTenantDeviceSubscription(item, params);
    }

    update(item: TenantDeviceSubscriptionModel, params?: RequestParams): Promise<TenantDeviceSubscriptionModel> {
        return ApiService.api.updateTenantDeviceSubscription(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TenantDeviceSubscriptionModel> {
        return ApiService.api.patchTenantDeviceSubscription(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<TenantDeviceSubscriptionModel>): Promise<CrudEnumerableResponse<TenantDeviceSubscriptionModel>> {
        return ApiService.api.deleteTenantDeviceSubscriptions(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error('NotImplemented');
    }
    
    download(query: CrudDataQuery<TenantDeviceSubscriptionModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: TenantDeviceSubscriptionModel, params?: RequestParams): Promise<CrudResponse<TenantDeviceSubscriptionModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
